"use strict";

const areasAndLengthCalculationType = "geodesic"
const slovakiaArcGisJson = {
  "geometry": {
    "rings": [
      [
        [19.675650121000047, 49.42671626500004],
        [19.71794208800003, 49.41850576500008],
        [19.796433147000073, 49.433115101000055],
        [19.840082864000067, 49.37697651900004],
        [19.833454849000077, 49.307810790000076],
        [19.853540433000035, 49.258314089000066],
        [19.797364849000076, 49.22835562100005],
        [19.851234635000026, 49.21657237200003],
        [19.889480329000037, 49.24537848800003],
        [19.952016108000066, 49.26369481300003],
        [20.021203764000063, 49.246871799000075],
        [20.051988856000037, 49.223584310000035],
        [20.096199055000056, 49.31448704600007],
        [20.16290392600007, 49.36409603700008],
        [20.267395758000077, 49.379286910000076],
        [20.30558449700004, 49.42763249800004],
        [20.446601360000045, 49.43761981200004],
        [20.548062483000024, 49.40677791600007],
        [20.62091590500006, 49.44012462000006],
        [20.762447658000042, 49.43523865000003],
        [20.82236131800005, 49.38204714800003],
        [20.897658208000053, 49.355436772000076],
        [20.93744169100006, 49.33054193400005],
        [20.987266886000043, 49.36095641900005],
        [21.024185051000075, 49.38031277200008],
        [21.00685273700003, 49.427356401000054],
        [21.124894133000055, 49.45955116500005],
        [21.184451273000036, 49.43166691600004],
        [21.245547316000057, 49.48061989200005],
        [21.32250828100007, 49.48026888900006],
        [21.389066128000024, 49.463242413000046],
        [21.44385636800007, 49.43678586100003],
        [21.561877966000054, 49.45710132600004],
        [21.65858453100003, 49.459578597000075],
        [21.688570046000052, 49.433498256000064],
        [21.782317824000074, 49.39691357400005],
        [21.836304932000075, 49.41498287500008],
        [21.902694772000075, 49.38681179100007],
        [21.99371811800006, 49.359011888000055],
        [22.03666559900006, 49.316180528000075],
        [22.082343594000065, 49.26772103900004],
        [22.086868468000034, 49.22888836900006],
        [22.18770745100005, 49.20894891200004],
        [22.25576514900007, 49.191621514000076],
        [22.280856877000076, 49.16558865500008],
        [22.345265936000033, 49.16749034900005],
        [22.408230037000067, 49.15156742400006],
        [22.44349400300007, 49.12231256200005],
        [22.501933114000053, 49.10471815300008],
        [22.56862312900006, 49.108555307000074],
        [22.59469377100004, 49.07082756800003],
        [22.58281594300007, 49.03913830000005],
        [22.534165533000078, 48.97105560700004],
        [22.48927314900004, 48.95356676600005],
        [22.45549730700003, 48.90908832800005],
        [22.459391142000072, 48.867557014000056],
        [22.420074955000075, 48.841235717000075],
        [22.430350314000066, 48.79224759400006],
        [22.39800144000003, 48.76200025300005],
        [22.402866251000034, 48.721112136000045],
        [22.379849858000057, 48.67190579100003],
        [22.31294331600003, 48.65094563900004],
        [22.258598319000043, 48.61057330500006],
        [22.19257670500008, 48.57360863500003],
        [22.16958394900007, 48.47038942800003],
        [22.16684230100003, 48.42417633200006],
        [22.175936223000065, 48.39850438800005],
        [22.164666814000043, 48.374273361000064],
        [22.13537027800004, 48.35836169700008],
        [22.09156005500006, 48.352677232000076],
        [22.037385777000054, 48.363952949000065],
        [21.98789195300003, 48.36045944600005],
        [21.916174197000032, 48.34343478900007],
        [21.86350591400003, 48.33543206500008],
        [21.849783627000022, 48.32248612600006],
        [21.816341738000062, 48.316600867000034],
        [21.76346456300007, 48.32035071400003],
        [21.713323295000066, 48.33192512200003],
        [21.679717872000026, 48.35929495100004],
        [21.649396826000043, 48.37992264600007],
        [21.621458260000054, 48.42061749900006],
        [21.602564441000027, 48.44813368600006],
        [21.599061307000056, 48.48142236500007],
        [21.574001343000077, 48.48865544500006],
        [21.54171957400007, 48.49163522900005],
        [21.512028170000065, 48.49966593100004],
        [21.495739439000033, 48.52135332100005],
        [21.479795210000077, 48.53955339300006],
        [21.442147135000027, 48.56097909400006],
        [21.43304074100007, 48.54716946900004],
        [21.413158719000023, 48.540124725000055],
        [21.383304989000067, 48.54267199600008],
        [21.343894920000025, 48.541597995000075],
        [21.317178590000026, 48.50756101500008],
        [21.283151323000027, 48.508406516000036],
        [21.245323747000043, 48.51441221200008],
        [21.214817453000023, 48.511768206000056],
        [21.173294750000025, 48.50170650900003],
        [21.149304019000056, 48.48561826500003],
        [21.125759061000053, 48.473080621000065],
        [21.090694280000037, 48.47856126600004],
        [21.074234772000068, 48.50207057500006],
        [21.046532181000032, 48.50641845000007],
        [21.015048044000025, 48.510568215000035],
        [20.988432299000067, 48.50503396100004],
        [20.953575560000047, 48.50572137800003],
        [20.901122905000022, 48.54160118100003],
        [20.856947235000064, 48.53720174400007],
        [20.82132497300006, 48.56210082200005],
        [20.686011630000053, 48.54730434100003],
        [20.59056190800004, 48.519985775000066],
        [20.56215581600003, 48.527313141000036],
        [20.534436369000048, 48.51530500300004],
        [20.521077469000033, 48.47639297000006],
        [20.490714113000024, 48.45841814000005],
        [20.47015192500004, 48.43039597000006],
        [20.445263519000036, 48.415335869000046],
        [20.436826538000048, 48.38343373300006],
        [20.432994284000074, 48.35341381600006],
        [20.406659327000057, 48.33409657800007],
        [20.385177000000056, 48.30732209100006],
        [20.357280428000024, 48.27968371900005],
        [20.33415898800007, 48.25608427200007],
        [20.29282574700005, 48.24736340700008],
        [20.250819471000057, 48.25656204400008],
        [20.22519220500004, 48.240328747000035],
        [20.169334482000068, 48.23512947800003],
        [20.109192290000067, 48.18955891100006],
        [20.07586499300004, 48.15816542300007],
        [20.00990234300008, 48.15319906700006],
        [19.959081645000026, 48.12278835500007],
        [19.919297338000035, 48.10707834300007],
        [19.876434747000076, 48.11302697200006],
        [19.88105306500006, 48.14372088400006],
        [19.863268566000045, 48.15433330900004],
        [19.832266142000037, 48.15130237000005],
        [19.786136059000057, 48.138108989000045],
        [19.75872047400003, 48.162221127000066],
        [19.777456683000025, 48.18401315700004],
        [19.746255460000043, 48.19518325700005],
        [19.71624065700007, 48.18325157600003],
        [19.686282623000068, 48.18545781600005],
        [19.66198024700003, 48.202573950000044],
        [19.646937638000054, 48.22424049500006],
        [19.615984556000058, 48.21581121400004],
        [19.57697163100005, 48.20128186300008],
        [19.54801306300004, 48.188304489000075],
        [19.533764450000035, 48.16485760100005],
        [19.52052434700005, 48.12346640700008],
        [19.507360980000044, 48.09303008400008],
        [19.493003572000077, 48.07768330400006],
        [19.459608958000047, 48.067434373000026],
        [19.434060361000036, 48.07768359200003],
        [19.39771293700005, 48.067895736000025],
        [19.30805392600007, 48.07359283800008],
        [19.25654933900006, 48.04171373600008],
        [19.142316335000032, 48.051233180000054],
        [19.06051814500006, 48.04386073400008],
        [19.017462554000076, 48.055820511000036],
        [18.997581635000074, 48.040208376000066],
        [18.92323338700004, 48.03971390500004],
        [18.847426017000032, 48.03253326200007],
        [18.84477321600008, 47.99398171300004],
        [18.82315123500007, 47.97745032300003],
        [18.78960951600004, 47.97071945500005],
        [18.791306660000032, 47.92411189100005],
        [18.78220423600004, 47.89942570000005],
        [18.797989533000077, 47.877134169000044],
        [18.842204656000035, 47.85843754900003],
        [18.878672765000033, 47.82353493100004],
        [18.858905282000023, 47.805808196000044],
        [18.806293951000043, 47.80775584300005],
        [18.759635683000056, 47.801138018000074],
        [18.74191773000007, 47.78081729300004],
        [18.71019024000003, 47.76154585000006],
        [18.66875431400007, 47.74572876500008],
        [18.593362202000037, 47.745350753000025],
        [18.54750686700004, 47.74934952800004],
        [18.499205501000063, 47.73759439500003],
        [18.462705929000037, 47.746993995000025],
        [18.27913014300003, 47.71808192800006],
        [18.03884174800004, 47.74182747700007],
        [18.00331856300005, 47.730588983000075],
        [17.78242255300006, 47.72255101600007],
        [17.69088948500007, 47.74982694800008],
        [17.600625105000063, 47.80398876300006],
        [17.551507152000056, 47.802227026000025],
        [17.515420041000027, 47.849750071000074],
        [17.446843667000053, 47.87252193200004],
        [17.39885593100007, 47.92060968900006],
        [17.32671154800005, 47.972365721000074],
        [17.248729842000046, 47.98284049000006],
        [17.205589402000044, 47.99483453000005],
        [17.158221800000035, 47.98860485300003],
        [17.10364442100007, 48.00087551000007],
        [17.040489232000027, 48.03428208200006],
        [17.03587320300005, 48.073379104000026],
        [17.05521061500002, 48.09967822300007],
        [16.95387007900007, 48.16319679700007],
        [16.91018930000007, 48.25309821600007],
        [16.817767418000074, 48.344442652000055],
        [16.808154380000076, 48.38093994700006],
        [16.827380455000025, 48.409207363000064],
        [16.830127037000068, 48.44748010300003],
        [16.88093880400004, 48.50119551000006],
        [16.916499531000056, 48.53947176100007],
        [16.909415817000024, 48.58219344300005],
        [16.918137020000074, 48.62413220600007],
        [16.936986915000034, 48.668206799000075],
        [17.000699772000075, 48.75336524800008],
        [17.06195321100006, 48.79718377700004],
        [17.088073820000034, 48.83697639500008],
        [17.177300814000034, 48.88649264400004],
        [17.23670401100003, 48.88134011100004],
        [17.323681501000067, 48.85755979900006],
        [17.381375226000046, 48.82803567700006],
        [17.42199698400003, 48.853846728000065],
        [17.473174726000025, 48.85869394000008],
        [17.521101033000036, 48.83658004100005],
        [17.577207780000037, 48.84496818800005],
        [17.61942321600003, 48.866487610000036],
        [17.678001395000024, 48.871898585000054],
        [17.753574682000078, 48.92892314300008],
        [17.824282760000074, 48.93849224200005],
        [17.86815013000006, 48.95197809700005],
        [17.909013426000058, 49.03009298100005],
        [17.97760153400003, 49.040604045000066],
        [18.03837703800002, 49.04456303200004],
        [18.080121262000034, 49.08098810200005],
        [18.080361823000032, 49.15104810200006],
        [18.09935299400007, 49.202565227000036],
        [18.10555539300003, 49.25098943900008],
        [18.16628173600003, 49.303955588000065],
        [18.321389085000078, 49.33207439700004],
        [18.371361463000028, 49.36942665500004],
        [18.366724065000028, 49.411658018000026],
        [18.431051625000066, 49.41395729000004],
        [18.504596526000057, 49.46996614500006],
        [18.517658248000032, 49.523279571000046],
        [18.61618888000004, 49.53041366300005],
        [18.735545681000076, 49.51740561200006],
        [18.832751243000075, 49.53507560600008],
        [18.951521765000052, 49.53451372300003],
        [19.003344351000067, 49.50238191100004],
        [18.999955191000026, 49.46078510700005],
        [19.013967629000035, 49.419961156000056],
        [19.09551780000004, 49.43665329000004],
        [19.153791617000024, 49.44260801000007],
        [19.191758358000072, 49.49702730300004],
        [19.22750017000004, 49.55092928000005],
        [19.331512901000053, 49.55681630400005],
        [19.38169536500004, 49.609687919000066],
        [19.468334413000036, 49.63928767700003],
        [19.524225278000074, 49.60765655500006],
        [19.563296514000058, 49.56541205100007],
        [19.594939623000073, 49.48393125100006],
        [19.67192090800006, 49.47238817900006],
        [19.675650121000047, 49.42671626500004],
      ],
    ],
    "spatialReference": {
      "wkid": 4326,
    },
  },
};

export default {
  areasAndLengthCalculationType,
  slovakiaArcGisJson,
  wkid: 4326,
};
